var map = {
	"./bucketservice-color-icon.png": 1151,
	"./cockpit-color-icon.png": 8257,
	"./goodin-color-icon.png": 3841,
	"./goodin-qa-color-icon.png": 3910,
	"./hub-color-icon.png": 5485,
	"./keepup-color-icon.png": 5922,
	"./knowlake-color-icon.png": 1049,
	"./ksm-color-icon.png": 7568,
	"./logicprint5-color-icon.png": 767,
	"./logicprint7-color-icon.png": 2692,
	"./logicprint7dollies-color-icon.png": 7355,
	"./packos-color-icon.png": 7480,
	"./workboost-color-icon.png": 2311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6164;